import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=fe98726a&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Change-Cycle-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe98726a')) {
      api.createRecord('fe98726a', component.options)
    } else {
      api.reload('fe98726a', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=fe98726a&", function () {
      api.rerender('fe98726a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Carousel.vue"
export default component.exports